// extracted by mini-css-extract-plugin
export default {"news":"news_news__wELKI"};